import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Toast from './Toast';
import { hideToast } from '../../store/features/toastSlice';
function ToastContainer() {
  const dispatch = useDispatch();
  const {
    show,
    message,
    variant
  } = useSelector(state => state.toast);
  if (!show) return null;
  return /*#__PURE__*/React.createElement(Toast, {
    show: show,
    message: message || '',
    variant: variant,
    onClose: () => dispatch(hideToast())
  });
}
export default ToastContainer;